<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidadesSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="unidadeSolicitanteNome"
                            v-model="model.unidadeSolicitanteId"
                            value-field="unidadeSolicitanteId"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidades"
                            label="Unidade executante"
                            show-default-option
                            text-field="unidadeNome"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            :validations="validations.unidadeId"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="exames"
                            defaultOptionText="Todos"
                            label="Exames"
                            show-default-option
                            text-field="exameNome"
                            v-model="model.exameId"
                            value-field="exameId"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Código procedimento"
                            v-model="model.procedimento"
                            number
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            class="float-left"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                            class="mr-2 float-left"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="notSaveLancamentos"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="notSaveLancamentos.length === 0"
                    @click="impressao()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="notSaveLancamentos.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :items="notSaveLancamentos"
                :fields="fields"
                ref="Table"
                sort-by="data"
                hide-filters
            >
                <template v-slot:cell(procedimento)="row">

                    <template v-if="row.item.procedimento === null || row.item.procedimento === ''|| row.item.procedimento === 0">
                       -
                    </template>

                    <template v-else>
                        {{ row.item.procedimento }}
                    </template>
                </template>

                <template v-slot:cell(nomeProcedimento)="row">

                    <template v-if="row.item.nomeProcedimento === null || row.item.nomeProcedimento === ''|| row.item.nomeProcedimento === 0">
                       SEM PROCEDIMENTO
                    </template>

                    <template v-else>
                        {{ row.item.nomeProcedimento }}
                    </template>
                </template>

                <template v-slot:cell(valorUnitario)="{item}">
                    R$ {{item.valorUnitario.replace('.',',')}}
                </template>

                <template v-slot:cell(valorTotal)="{item}">
                    R$ {{valorTotalExames(item)}}
                </template>

                <template v-slot:custom-foot>
                    <rkm-tr>
                        <rkm-th :colspan="cols.length + 7" class="table-td">
                            <rkm-row>
                                <rkm-col cols="6"></rkm-col>
                                <rkm-col cols="6" class="text-right">Total geral: R$ {{ totalGeral() }}</rkm-col>
                            </rkm-row>
                        </rkm-th>
                    </rkm-tr>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>

// Mixins.
import { repository, error, object, data, stringCase, formats, file } from '@/mixins'

// Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

export default {
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
            relatorio: this.getConectaSusRepository('exameImagem.relatorioFinanceiroExame'),
            exportacao: this.getConectaSusRepository('exportacao.exameImagem'),
        }
        this.load()
    },
    computed: {
        fields() {
            let fields = [
                { key: 'procedimento', label: 'Código', sortable: true },
                { key: 'nomeProcedimento', label: 'Procedimento', sortable: true },
                { key: 'exameNome', label: 'Exame', sortable: true },
                { key: 'quantidade', label: 'Quantidade', sortable: true },
                { key: 'valorUnitario', label: 'Valor Unit.', sortable: true },
                { key: 'valorTotal', label: 'Valor Total', sortable: true },
                { key: 'statusNome', label: 'Status', sortable: true},
            ]

            this.selectedCols.map(map => {

                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true })
            })

            return fields
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        unidadesSolicitante(){

            let unidadeSolicitanteOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidadesSolicitante()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioFinanceiroExame.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
                        .map(unidade => {

                            let verifyUnidade = unidadeSolicitanteOrigem.find(u => u.unidadeSolicitanteId === unidade.unidadeSolicitanteId)

                            if(!verifyUnidade){

                                unidadeSolicitanteOrigem.push({

                                    unidadeSolicitanteId: unidade.unidadeSolicitanteId,
                                    unidadeSolicitanteNome: unidade.unidadeSolicitanteNome
                                })
                            } else {

                                this.resetUnidadesSolicitante()
                                this.resetDatatable()
                            }
                        })
            }

            return unidadeSolicitanteOrigem
        },
        unidades(){

            let unidadeOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidade()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioFinanceiroExame.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                        && agendamento.unidadeSolicitanteId === this.model.unidadeSolicitanteId)
                            .map(unidade => {

                                let verifyUnidade = unidadeOrigem.find(u => u.unidadeId === unidade.unidadeId)

                                if(!verifyUnidade){

                                    unidadeOrigem.push({

                                        unidadeId: unidade.unidadeId,
                                        unidadeNome: unidade.nomeFantasia
                                    })
                                } else {

                                    this.resetUnidade()
                                    this.resetDatatable()
                                }
                            })
            }

            return unidadeOrigem
        },
        exames(){

            let exameOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetExames()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                if(this.verificaUnidade == true){

                    this.data.model.relatorioFinanceiroExame.filter(e => moment(e.data, 'DD/MM/YYYY').isBetween(start, end)
                        && e.unidadeSolicitanteId === this.model.unidadeSolicitanteId && e.unidadeId === this.model.unidadeId)
                            .map(exame => {

                                if (exameOrigem) {

                                    let verifyExame = exameOrigem.find(u => u.exameId === exame.exameId)

                                    if (!verifyExame) {

                                        exameOrigem.push({

                                            exameId: exame.exameId,
                                            exameNome: exame.exameNome,
                                        })
                                    } else {

                                        this.resetExames()
                                        this.resetDatatable()
                                    }
                                }
                            })

                    exameOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));

                } else {

                    this.data.model.relatorioFinanceiroExame.filter(e => moment(e.data, 'DD/MM/YYYY').isBetween(start, end)
                        && e.unidadeSolicitanteId === this.model.unidadeSolicitanteId)
                            .map(exame => {

                                if (exameOrigem) {

                                    let verifyExame = exameOrigem.find(u => u.exameId === exame.exameId)

                                    if (!verifyExame) {

                                        exameOrigem.push({

                                            exameId: exame.exameId,
                                            exameNome: exame.exameNome,
                                        })
                                    } else {

                                        this.resetExames()
                                        this.resetDatatable()
                                    }
                                }
                            })

                    exameOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));
                }
            }

            return exameOrigem
        },
    },
    data: () => ({
        notSaveLancamentos: null,
        model: {
            prontuario: '',
            periodo: {
                start: null,
                end: null,
            },
            paciente: null,
            exameId: null,
            unidadeId: null,
            unidadeSolicitanteId: null,
            statusId: null,
            procedimento: '',
        },
        indeterminate: false,
        additionals: {},
        enums:{
            statusFechamento,
        },
        selectedCols: [],
        cols: [
            { value: 'unidadeSolicitanteNome', text: 'Unidade solicitante', },
            { value: 'nomeFantasia', text: 'Unidade executante', },
        ],
        verificaUnidade: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
        },
        search() {

            this.setLoading()

            this.repositories.relatorio.datatable(this.getSearchParams())
                .then(({ data }) => {

                    this.notSaveLancamentos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDefaultValues() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
            this.resetDatatable()
        },
        getSearchParams() {
            const params = this.clone(this.model)
            this.formateDates(params.periodo, ['start', 'end'], 'DD/MM/YYYY')
            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetDatatable(){
            this.notSaveLancamentos = null
            this.model.procedimento = null
            this.model.exame = null
        },
        resetUnidade(){
            this.model.unidadeId = null
        },
        resetUnidadesSolicitante(){
            this.model.unidadeSolicitanteId = null
        },
        resetExames(){
            this.model.exameId = null
        },
        resetForm() {
            this.model.unidadeId = null
            this.model.unidadeSolicitanteId = null
            this.model.exame = null
            this.model.procedimento = null

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        impressao() {

            this.setLoading()

            const filter = this.getFilterExportPrint()

            filter.columns = this.fields

            this.repositories.impressao.relatorioFinanceiroExame(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')
                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        exportar() {

            this.setLoading()

            const filter = this.getFilterExportPrint()
            filter.columns = this.fields

            this.repositories.exportacao.exportFinanceiroExame(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        getFilterExportPrint() {

            const filter = this.getSearchParams()

            const $this = this

            const cols = this.fields.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            const valorUnidade = this.notSaveLancamentos.map(field => field.valorUnitario * field.quantidade)
            const valores = valorUnidade;
            const totalGeral = valores.reduce((total, numero) => total + numero, 0);
            filter.totalGeral = this.formatMoney(totalGeral, 2)

            const solicitantes = this.data.form.unidadesSolicitantes.find(u => u.id === this.model.unidadeSolicitanteId)
            filter.solicitantes = solicitantes ? solicitantes.nomeFantasia : 'Todas'

            const executantes = this.data.form.unidadesExecutantes.find(u => u.id === this.model.unidadeId)
            filter.executantes = executantes ? executantes.nomeFantasia : 'Todas'

            const exame = this.data.form.exames.find(e => e.id === this.model.exameId)
            filter.exame = exame ? exame.nome : 'Todos'

            return filter
        },
        totalGeral(){
            let valorUnidade = this.notSaveLancamentos.map(field => field.valorUnitario * field.quantidade)
            let valores = valorUnidade;
            let total = valores.reduce((total, numero) => total + numero, 0);
            return this.formatMoney(total, 2)
        },
        valorTotalExames(item){
            let valorTotal = item.valorUnitario * item.quantidade
            return this.formatMoney(valorTotal, 2)
        },
    },
    mixins: [repository, error, object, data, stringCase, formats, file],
    watch: {
        'model.unidadeId': function(){

            if(this.model.unidadeId == null || this.model.unidadeId == ''){
                this.verificaUnidade = false
            } else {
                this.verificaUnidade = true
            }
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
    .warning {
        color: var(--warning);
    }
</style>